import React from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const FilterSidebar = ({ filters, activeFilters, onFilterChange, onClearFilters }) => {
  const hasActiveFilters = Object.values(activeFilters)?.some(Boolean);

  return (
    <div className="w-64 bg-white border border-gray-200 rounded-xl p-6 h-fit sticky top-20 shadow-sm">
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
        <h3 className="text-base font-semibold text-gray-900 tracking-tight">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className="text-gray-500 hover:text-gray-900 text-xs font-medium"
          >
            Clear All
          </Button>
        )}
      </div>
      <div className="space-y-7">
        {filters?.map((filterGroup, idx) => (
          <div key={filterGroup?.key} className={idx > 0 ? 'pt-6 border-t border-gray-100' : ''}>
            <h4 className="text-sm font-semibold text-gray-900 mb-3.5 flex items-center gap-2">
              <Icon name={filterGroup?.icon} size={15} className="text-gray-400" />
              {filterGroup?.label}
            </h4>
            <div className="space-y-2.5">
              {filterGroup?.options?.map((option) => {
                const checked = activeFilters?.[`${filterGroup?.key}_${option?.value}`] || false;
                return (
                  <label
                    key={option?.value}
                    className="flex items-center justify-between cursor-pointer group"
                  >
                    <span className="flex items-center gap-2.5">
                      <Checkbox
                        checked={checked}
                        onChange={(e) => onFilterChange(`${filterGroup?.key}_${option?.value}`, e?.target?.checked)}
                      />
                      <span className={`text-sm ${checked ? 'text-gray-900 font-medium' : 'text-gray-700'} group-hover:text-gray-900 transition-colors`}>
                        {option?.label}
                      </span>
                    </span>
                    <span className="text-xs text-gray-400 font-medium tabular-nums">
                      {option?.count}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSidebar;